export default [
    // -- without menu routes --
    {
        path: '/login',
        name: 'login',
        component: () => import('@views/login/login.vue'),
        meta: {
            rule: 'isPublic',
            layout: 'login',
        },
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@views/reset-password/reset-password.vue'),
        meta: {
            rule: 'isPublic',
            layout: 'login',
        },
    },
    {
        path: '/error',
        name: 'error',
        component: require('@views/error/error.vue').default,
        // Allows props to be passed to the error page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
        meta: {
            rule: 'isPublic',
        },
    },
    {
        path: '/choose-location',
        name: 'choose-location',
        component: () => import('@views/choose-location/choose-location.vue'),
        meta: {
            rule: 'isLogged',
            layout: 'login',
        },
    },

    // -- routes with menu --

    // // TODO: remover após teste
    // // errorTest
    // {
    //     path: '/errorTest',
    //     type: 'menu',
    //     name: 'TESTE TELA DE ERROS',
    //     icon: 'icn_assessment',
    //     component: () => import('@views/errorTest/errorTest.vue'),
    //     meta: {
    //         rule: 'ForgotPassword',
    //     },
    // },

    // =====================================================================================
    // Assessment model
    {
        path: '/assessments-model',
        type: 'menu',
        name: 'Menu.assessmentModel',
        icon: 'icn_assessment',
        component: () => import('@views/assessment-model/assessment-model.vue'),
        meta: {
            rule: 'GetAllAssessments',
            module: 'Assessment',
        },
    },

    // Assessment model => new
    {
        path: '/assessment-model/new',
        type: 'menu',
        name: 'Menu.newAssessmentModel',
        icon: 'icn_assessment',
        component: () =>
            import('@views/assessment-model/assessment-model-form.vue'),
        meta: {
            rule: 'PostAssessment',
            backButton: true,
            module: 'Assessment',
        },
    },

    // Assessment model => edit
    {
        path: '/assessment-model/:id',
        type: 'menu',
        name: 'Menu.editAssessmentModel',
        icon: 'icn_assessment',
        component: () =>
            import('@views/assessment-model/assessment-model-form.vue'),
        meta: {
            rule: 'PutAssessment',
            backButton: true,
            module: 'Assessment',
        },
    },

    // Assessment question => new
    {
        path: '/assessment-model/:id/question',
        type: 'menu',
        name: 'Menu.newAssessmentQuestion',
        icon: 'icn_assessment',
        component: () =>
            import(
                '@views/assessment-model/assessment-question/assessment-question-form.vue'
            ),
        meta: {
            rule: 'PutAssessment',
            backButton: true,
            module: 'Assessment',
        },
    },

    // Assessment question => edit
    {
        path: '/assessment-model/:id/question/:qid',
        type: 'menu',
        name: 'Menu.editAssessmentQuestion',
        icon: 'icn_assessment',
        component: () =>
            import(
                '@views/assessment-model/assessment-question/assessment-question-form.vue'
            ),
        meta: {
            rule: 'PutAssessment',
            backButton: true,
            module: 'Assessment',
        },
    },

    // Modulo Avaliacao
    /* {
        path: '/moduloavaliacao',
        type: 'menu',
        name: 'Menu.assessmentStudentsNewModule',
        icon: 'icn_locals',
        meta: {
            rule: 'AssessmentApplicationList',
        },
    }, */

    // Pagina explicativa
    {
        path: '/newpanel',
        type: 'menu',
        name: 'Menu.assessmentStudentsNewModule',
        icon: 'icn_assessment',
        component: () => import('@views/provisory-page/provisory-page.vue'),
        meta: {
            rule: 'AssessmentApplicationList',
        },
    },

    // Assessment students => check assessment
    {
        path: '/assessment-students/assessment-result/:id',
        type: 'menu',
        name: 'Menu.assessmentResult',
        icon: 'icn_assessment',
        component: () =>
            import('@views/assessment-students/assessment-result.vue'),
        meta: {
            rule: 'AssessmentApplicationReport',
            backButton: true,
            module: 'AssessmentStudents',
        },
    },

    // Assessment students => assessment application
    {
        path: '/assessment-students/assessment-application',
        type: 'menu',
        name: 'Menu.assessmentApplication',
        icon: 'icn_assessment',
        component: () =>
            import('@views/assessment-students/assessment-application.vue'),
        meta: {
            rule: 'AssessmentApplicationReport',
            backButton: true,
            module: 'AssessmentStudents',
        },
    },

    // =====================================================================================
    // Occupation map
    {
        path: '/',
        name: 'Menu.occupancyMap',
        component: () => import('@views/occupancy-map/occupancy-map.vue'),
        meta: {
            rule: 'GetOccupancyMap',
            module: 'OccupancyMap',
        },
        type: 'menu',
        icon: 'icn_mapa',
    },

    // Occupation map => seeLesson
    {
        path: '/occupancyMap/lesson/:id/date/:date',
        name: 'Menu.classLesson',
        component: () => import('@views/occupancy-map/lesson.vue'),
        meta: {
            rule: 'GetOccupancyMap',
            backButton: true,
            module: 'OccupancyMap',
        },
        type: 'menu',
        icon: 'icn_mapa',
    },

    // =====================================================================================
    // Assessments List
    {
        path: '/assessments/all',
        type: 'menu',
        name: 'Menu.assessmentsList',
        icon: 'icn_assessment',
        component: () => import('@views/home/home.vue'),
        meta: {
            rule: 'PoolAndTeam',
        },
    },

    // =====================================================================================
    // Classgrade
    /* {
        path: '/classgrade',
        type: 'menu',
        name: 'Menu.classgrade',
        icon: 'icn_class',
        component: () => import('@views/classgrade/classgrade.vue'),
        meta: {
            rule: 'GetClassGradesByLocation',
            module: 'ClassGrade',
        },
    }, */

    // Classgrade => new
    /* {
        path: '/classgrade/new',
        type: 'menu',
        name: 'Menu.newClassgrade',
        icon: 'icn_class',
        component: () => import('@views/classgrade/classgrade-form.vue'),
        meta: {
            rule: 'PostClassGrade',
            isDuplicating: false,
            backButton: true,
            module: 'ClassGrade',
        },
    }, */

    // Classgrade => edit
    {
        path: '/classgrade/:id',
        type: 'menu',
        name: 'Menu.editClassGrade',
        icon: 'icn_class',
        component: () => import('@views/classgrade/classgrade-form.vue'),
        meta: {
            rule: 'PutClassGrade',
            backButton: true,
            module: 'ClassGrade',
        },
    },

    // =====================================================================================
    // Clients
    {
        path: '/clients',
        type: 'menu',
        name: 'Menu.clients',
        icon: 'icn_networks',
        component: () => import('@views/clients/clients.vue'),
        meta: {
            rule: 'GetClients',
            module: 'Clients',
        },
    },
    // Clients => new
    {
        path: '/clients/new',
        type: 'menu',
        name: 'Menu.newClient',
        icon: 'icn_content',
        component: () => import('@views/clients/clients-form.vue'),
        meta: {
            rule: 'PostClient',
            backButton: true,
            isDuplicating: false,
            module: 'Clients',
        },
    },
    // Clients => edit
    {
        path: '/clients/edit/:id',
        type: 'menu',
        name: 'Menu.editClient',
        icon: 'icn_content',
        component: () => import('@views/clients/clients-form.vue'),
        meta: {
            rule: 'PutClient',
            backButton: true,
            module: 'Clients',
        },
    },

    // =====================================================================================
    // Contents
    {
        path: '/contents',
        type: 'menu',
        name: 'Menu.contents',
        icon: 'icn_content',
        component: () => import('@views/content/content.vue'),
        meta: {
            rule: 'GetContents',
            module: 'Contents',
        },
    },

    // Contents => new
    {
        path: '/contents/new',
        type: 'menu',
        name: 'Menu.newContent',
        icon: 'icn_content',
        component: () => import('@views/content/content-form.vue'),
        meta: {
            rule: 'PostContent',
            backButton: true,
            isDuplicating: false,
            module: 'Contents',
        },
    },
    // Contents => edit
    {
        path: '/contents/edit/:id',
        type: 'menu',
        name: 'Menu.editContent',
        icon: 'icn_content',
        component: () => import('@views/content/content-form.vue'),
        meta: {
            rule: 'PutContent',
            backButton: true,
            module: 'Contents',
        },
    },

    // =====================================================================================
    // Goals
    {
        path: '/goals',
        type: 'menu',
        name: 'Menu.goals',
        icon: 'icn_objetivos',
        component: () => import('@views/goal/goal.vue'),
        meta: {
            rule: 'GetGoals',
            module: 'Goals',
        },
    },

    // Goals => new
    {
        path: '/goals/new',
        type: 'menu',
        name: 'Menu.newGoal',
        icon: 'icn_objetivos',
        component: () => import('@views/goal/goal-form.vue'),
        meta: {
            rule: 'PostGoal',
            backButton: true,
            module: 'Goals',
        },
    },

    // Goals  => edit
    {
        path: '/goals/edit/:id',
        type: 'menu',
        name: 'Menu.editGoal',
        icon: 'icn_objetivos',
        component: () => import('@views/goal/goal-form.vue'),
        meta: {
            rule: 'PutGoal',
            backButton: true,
            module: 'Goals',
        },
    },

    // =====================================================================================
    // Locations
    {
        path: '/locations',
        type: 'menu',
        name: 'Menu.locations',
        icon: 'icn_licensed',
        component: () => import('@views/locations/locations.vue'),
        meta: {
            rule: 'GetLocation',
            module: 'Locations',
        },
    },
    // Locations => new
    {
        path: '/locations/new',
        type: 'menu',
        name: 'Menu.newLocation',
        icon: 'icn_content',
        component: () => import('@views/locations/locations-form.vue'),
        meta: {
            rule: 'PostLocation',
            backButton: true,
            isDuplicating: false,
            module: 'Locations',
        },
    },
    // Locations => edit
    {
        path: '/locations/edit/:id',
        type: 'menu',
        name: 'Menu.editLocation',
        icon: 'icn_content',
        component: () => import('@views/locations/locations-form.vue'),
        meta: {
            rule: 'PutLocation',
            backButton: true,
            module: 'Locations',
        },
    },
    // Location Buyers => shopkeeper
    {
        path: '/location/:id/location-buyer',
        type: 'menu',
        name: 'Menu.locationBuyers',
        icon: 'icn_content',
        component: () => import('@views/location-buyers/location-buyers.vue'),
        meta: {
            rule: 'GetLocationStoresByLocation',
            backButton: true,
            module: 'Locations',
        },
    },
    // Location Buyers => new shopkeeper
    {
        path: '/location/:id/location-buyer/new',
        type: 'menu',
        name: 'Menu.newLocationBuyer',
        component: () =>
            import('@views/location-buyers/location-buyers-form.vue'),
        meta: {
            rule: 'PostLocationStore',
            backButton: true,
            isDuplicating: false,
            module: 'Locations',
        },
    },
    // Location Buyers => edit shopkeeper
    {
        path: '/location/:id/location-buyer/:lid',
        type: 'menu',
        name: 'Menu.editLocationBuyer',
        component: () =>
            import('@views/location-buyers/location-buyers-form.vue'),
        meta: {
            rule: 'PutLocationStore',
            backButton: true,
            module: 'Locations',
        },
    },

    // =====================================================================================
    // LocationStores / Ecommerce
    /* {
        path: '/locations-stores',
        type: 'menu',
        name: 'Menu.showStores',
        icon: 'icn_shop',
        component: () =>
            import('@views/ecommerce-location-stores/locations-stores.vue'),
        meta: {
            module: 'Locations',
            rule: 'GetLocationStoresByLocation',
        },
    }, */

    // =====================================================================================
    // Plans
    /* {
        path: '/plans',
        type: 'menu',
        name: 'Menu.plans',
        icon: 'icn_plans',
        component: () => import('@views/plans/plans.vue'),
        meta: {
            module: 'Plans',
            rule: 'GetPlans',
        },
    }, */

    // Plans => new
    /* {
        path: '/plans/new',
        name: 'Menu.newPlans',
        component: () => import('@views/plans/plans-form.vue'),
        meta: {
            rule: 'PostPlan',
            backButton: true,
            module: 'Plans',
        },
    }, */

    // Plans => edit
    /* {
        path: '/plans/edit/:id',
        name: 'Menu.editPlan',
        component: () => import('@views/plans/plans-form.vue'),
        meta: {
            rule: 'PutPlan',
            backButton: true,
            module: 'Plans',
        },
    },
 */
    // =====================================================================================
    // Responsibles
    /* {
        path: '/responsible',
        type: 'menu',
        name: 'Menu.responsible',
        icon: 'icn_users',
        component: () => import('@views/responsible/responsible.vue'),
        meta: {
            rule: 'GetResponsibles',
            module: 'Responsible',
        },
    }, */

    // Responsibles => new
    /* {
        path: '/responsible/new',
        type: 'menu',
        name: 'Menu.newResponsible',
        icon: 'icn_users',
        component: () => import('@views/responsible/responsible-form.vue'),
        meta: {
            rule: 'GetResponsible',
            isDuplicating: false,
            backButton: true,
            module: 'Responsible',
        },
    }, */

    // Responsibles => edit
    /* {
        path: '/responsible/:id',
        type: 'menu',
        name: 'Menu.editResponsible',
        icon: 'icn_users',
        component: () => import('@views/responsible/responsible-form.vue'),
        meta: {
            rule: 'PostResponsible',
            backButton: true,
            module: 'Responsible',
        },
    }, */

    // =====================================================================================
    // ScheduleMap
    {
        path: '/schedule-map',
        type: 'menu',
        name: 'Menu.scheduleMap',
        icon: 'icn_schedule_map',
        component: () => import('@views/schedule-map/schedule-map.vue'),
        meta: {
            module: 'ScheduleMap',
            rule: 'GetSchedule',
        },
    },

    // ScheduleMap => new
    {
        path: '/schedule-map/new',
        type: 'menu',
        name: 'Menu.newScheduleMap',
        icon: 'icn_schedule_map',
        component: () => import('@views/schedule-map/schedule-map-form.vue'),
        meta: {
            module: 'ScheduleMap',
            rule: 'PostSchedule',
            backButton: true,
        },
    },

    // ScheduleMap => edit
    {
        path: '/schedule-map/:id',
        type: 'menu',
        name: 'Menu.editScheduleMap',
        icon: 'icn_schedule_map',
        component: () => import('@views/schedule-map/schedule-map-form.vue'),
        meta: {
            rule: 'PutSchedule',
            module: 'ScheduleMap',
            backButton: true,
        },
    },

    // ScheduleMap => new => scheduleConfig
    {
        path: '/schedule-map/:id/new/schedule-config',
        type: 'menu',
        name: 'Menu.newLesson',
        icon: 'icn_schedule_map',
        component: () =>
            import(
                '@views/schedule-map/schedule-config/schedule-config-form.vue'
            ),
        meta: {
            module: 'ScheduleMap',
            rule: 'PostScheduleConfig',
            backButton: true,
        },
    },

    // ScheduleMap => edit => scheduleConfig
    {
        path: '/schedule-map/:id/schedule-config/:sid',
        type: 'menu',
        name: 'Menu.editLesson',
        icon: 'icn_schedule_map',
        component: () =>
            import(
                '@views/schedule-map/schedule-config/schedule-config-form.vue'
            ),
        meta: {
            module: 'ScheduleMap',
            rule: 'PutScheduleConfig',
            backButton: true,
        },
    },

    // =====================================================================================
    // Staff
    {
        path: '/staff',
        type: 'menu',
        name: 'Menu.staff',
        icon: 'icn_user_admin',
        component: () => import('@views/staff/staff.vue'),
        meta: {
            module: 'Staff',
            rule: 'GetStaffs',
        },
    },

    // Staff -- new
    {
        path: '/staff/new',
        name: 'Menu.newStaff',
        icon: 'icn_user_admin',
        component: () => import('@views/staff/staff-form.vue'),
        meta: {
            module: 'Staff',
            rule: 'PostStaff',
            backButton: true,
        },
    },

    // Staff -- edit
    {
        path: '/staff/edit/:id',
        type: 'menu',
        name: 'Menu.editStaff',
        icon: 'icn_user_admin',
        component: () => import('@views/staff/staff-form.vue'),
        meta: {
            module: 'Staff',
            rule: 'PutStaff',
            backButton: true,
        },
    },

    // =====================================================================================
    // Students
    /* {
        path: '/students',
        type: 'menu',
        name: 'Menu.students',
        icon: 'icn_customers',
        component: () => import('@views/student/student.vue'),
        meta: {
            module: 'Student',
            rule: 'GetStudents',
        },
    }, */

    // Students => new
    /* {
        path: '/students/new',
        type: 'menu',
        name: 'Menu.newStudent',
        icon: 'icn_customers',
        component: () => import('@views/student/student-form.vue'),
        meta: {
            rule: 'PostStudent',
            isDuplicating: false,
            module: 'Student',
            backButton: true,
        },
    }, */

    // Students => put
    /* {
        path: '/student/:id',
        type: 'menu',
        name: 'Menu.editStudent',
        icon: 'icn_customers',
        component: () => import('@views/student/student-form.vue'),
        meta: {
            module: 'Student',
            rule: 'PutStudent',
            backButton: true,
        },
    }, */

    // Courses
    /* {
        meta: {
            rule: 'LoginUnique',
        },
        path: '/courses',
        name: 'Menu.courses',
        type: 'menu',
        icon: 'icn_courses',
    }, */

    // Certifications
    /* {
        meta: {
            rule: 'LoginUnique',
            layout: 'blank',
        },
        component: () =>
            import('@views/certification-iframe/certification-iframe.vue'),
        path: '/certification',
        name: 'Menu.certification',
        type: 'menu',
        icon: 'icn_certification',
    }, */

    // FAQ
    /* {
        meta: {
            rule: 'LoginUnique',
        },
        path: '/faq',
        name: 'Menu.faq',
        type: 'menu',
        icon: 'icn_question',
    }, */

    // =====================================================================================
    // Teaching Areas
    /* {
        path: '/teachingAreas',
        type: 'menu',
        name: 'Menu.teachingAreas',
        icon: 'icn_locals',
        component: () => import('@views/teaching-area/teaching-area.vue'),
        meta: {
            rule: 'GetTeachingAreas',
            module: 'teachingAreas',
        },
    }, */
    // Teaching Areas => new
    /* {
        path: '/teachingAreas/new',
        type: 'menu',
        name: 'Menu.newTeachingAreas',
        icon: 'icn_locals',
        component: () => import('@views/teaching-area/teaching-area-form.vue'),
        meta: {
            rule: 'PostTeachingArea',
            module: 'teachingAreas',
            backButton: true,
        },
    }, */

    // Teaching Areas => edit
    /* {
        path: '/teachingAreas/edit/:id',
        type: 'menu',
        name: 'Menu.editTeachingAreas',
        icon: 'icn_locals',
        component: () => import('@views/teaching-area/teaching-area-form.vue'),
        meta: {
            rule: 'PutTeachingArea',
            backButton: true,
            module: 'teachingAreas',
        },
    }, */

    // =====================================================================================
    // Team
    /* {
        path: '/team',
        type: 'menu',
        name: 'Menu.team',
        icon: 'icn_users',
        component: () => import('@views/team/team.vue'),
        meta: {
            rule: 'GetTeamsByLocation',
            module: 'Team',
        },
    }, */

    // Team -- new
    /* {
        path: '/team/new',
        name: 'Menu.newTeam',
        icon: 'icn_users',
        component: () => import('@views/team/team-form.vue'),
        meta: {
            rule: 'PostTeam',
            backButton: true,
            isDuplicating: false,
            module: 'Team',
        },
    }, */

    // Team -- edit
    /* {
        path: '/team/edit/:id',
        type: 'menu',
        name: 'Menu.editTeam',
        icon: 'icn_users',
        component: () => import('@views/team/team-form.vue'),
        meta: {
            rule: 'PutTeam',
            backButton: true,
            module: 'Team',
        },
    }, */

    // Uploads
    {
        path: '/file-manager',
        type: 'menu',
        name: 'Menu.uploads',
        icon: 'icn_download',
        component: () => import('@views/file-manager/file-manager.vue'),
        meta: {
            rule: 'GetAll',
            module: 'Upload',
        },
    },

    // Downloads
    // {
    //     path: '/downloads',
    //     type: 'menu',
    //     name: 'Menu.downloads',
    //     icon: 'icn_download',
    //     component: () => import('@views/file-manager/file-manager.vue'),
    //     meta: {
    //         rule: 'GetAll',
    //         module: 'Download',
    //     },
    // },

    // Partners
    /* {
        path: '/partners',
        type: 'menu',
        name: 'Menu.partners',
        icon: 'icn_download',
        component: () => import('@views/partners/partners.vue'),
        meta: {
            rule: 'GetPartners',
            module: 'Partner',
        },
    }, */

    // Partners new
    {
        path: '/partners/new',
        type: 'menu',
        name: 'Menu.newPartner',
        icon: 'icn_download',
        component: () => import('@views/partners/partners-form.vue'),
        meta: {
            rule: 'PostPartner',
            backButton: true,
            module: 'Partner',
        },
    },

    // Partners edit
    {
        path: '/partners/:id',
        type: 'menu',
        name: 'Menu.editPartner',
        icon: 'icn_download',
        component: () => import('@views/partners/partners-form.vue'),
        meta: {
            rule: 'PostPartner',
            backButton: true,
            module: 'Partner',
        },
    },

    // Partner management
    {
        path: '/partner-management',
        type: 'menu',
        name: 'Menu.partnerManagement',
        icon: 'icn_download',
        component: () =>
            import('@views/partner-management/partner-management.vue'),
        meta: {
            rule: 'GetPlans',
            module: 'PartnerManagement',
        },
    },

    // Partners new
    {
        path: '/partner-management/new',
        type: 'menu',
        name: 'Menu.newPartnerToken',
        icon: 'icn_download',
        component: () =>
            import('@views/partner-management/partner-management-form.vue'),
        meta: {
            rule: 'PostPlan',
            backButton: true,
            module: 'PartnerManagement',
        },
    },

    // // Partners edit
    // {
    //     path: '/partners/:id',
    //     type: 'menu',
    //     name: 'Menu.editPartner',
    //     icon: 'icn_download',
    //     component: () => import('@views/partners/partners-form.vue'),
    //     meta: {
    //         rule: 'PostPartner',
    //         backButton: true,
    //         module: 'Partner',
    //     },
    // },

    // Integration
    /* {
        path: '/integration',
        type: 'menu',
        name: 'Menu.integration',
        icon: 'icn_api',
        component: () => import('@views/integration/integration.vue'),
        meta: {
            rule: 'GetLocationPartners',
            module: 'Integration',
        },
    }, */

    // Integration => new
    {
        path: '/integration/new',
        type: 'menu',
        name: 'Menu.newIntegration',
        icon: 'icn_api',
        component: () => import('@views/integration/integration-form.vue'),
        meta: {
            rule: 'PostLocationPartner',
            backButton: true,
            module: 'Integration',
        },
    },
    // Attendance
    {
        path: '/attendance/',
        type: 'menu',
        name: 'Menu.attendance',
        icon: 'icn_api',
        component: () => import('@views/attendance/attendance.vue'),
        meta: {
            rule: 'PostLocationPartner',
            backButton: true,
            module: 'Attendance',
        },
    },
    // Profile Page
    // Attendance
    {
        path: '/my-profile/',
        type: 'menu',
        name: 'Menu.profile',
        icon: 'icn_api',
        component: () => import('@views/profile-page/profile-page.vue'),
        meta: {
            rule: 'PostLocationPartner',
            backButton: true,
            module: 'Profile',
        },
    },
]
